export default {
    server: { 
        //API_URI:'http://38.25.97.226:3000/api',
        API_URI_TI:'https://apiv2.tdemperu.com/api',
        API_URI_TDEM:'https://tdemperu.com/consulta-certificado-inacal/api'
    }
}